import { render, staticRenderFns } from "./editAccountConfig.vue?vue&type=template&id=2bd378a8&scoped=true"
import script from "./editAccountConfig.vue?vue&type=script&lang=ts"
export * from "./editAccountConfig.vue?vue&type=script&lang=ts"
import style0 from "./editAccountConfig.vue?vue&type=style&index=0&id=2bd378a8&prod&lang=scss&scoped=true"
import style1 from "./editAccountConfig.vue?vue&type=style&index=1&id=2bd378a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd378a8",
  null
  
)

export default component.exports